<script>
import { tableRelevant } from "@/pages/projectImpl/js/utils";

export default {
  name: "selectCourse",
  props: {
    courseType: Number,
    organizationId: Number,
    contentId: [String, Number],
    selectCourse: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  model: {
    prop: "selectCourse",
    event: "change",
  },
  data() {
    return {
      loading: false,
      tabs: [
        { type: 1, name: "B端" },
        { type: 2, name: "C端" },
        { type: 3, name: "实验" },
      ],
      tabActive: 1,
      tree: {
        key: Date.now(),
        selectValue: undefined,
        treeLoading: false,
        treeData: [],
      },
      defaultExpandedRowKeys: [],
      columns: [
        { title: "课程系列", dataIndex: "name", width: 250, ellipsis: true },
        { title: "系列说明", dataIndex: "remark", ellipsis: true },
      ],
      table: tableRelevant.call(this, this.getSeriesList),
      childColumns: [
        { title: "课程名称", scopedSlots: { customRender: "name" } },
        { title: "适用学段", dataIndex: "period", width: 100 },
        { title: "类型", dataIndex: "courseType", width: 90, scopedSlots: { customRender: "courseType" } },
        { title: "课时数", width: 80, dataIndex: "courseSessionCount" },
        { title: "报告数", width: 80, dataIndex: "reportCount" },
        { title: "价格", dataIndex: "price", width: 90, scopedSlots: { customRender: "price" } },
      ],
      childTable: tableRelevant.call(this),
      searchForm: {
        name: undefined,
        courseName: undefined,
        remark: undefined,
        classificationId: undefined,
      },
    };
  },
  computed: {
    childTableSelection() {
      return {
        selectedRowKeys: this.childTable.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.childTable.selectedRowKeys = selectedRowKeys;
          this.childTable.selectedRows = selectedRows.concat(this.childTable.selectedRows).reduce((pre, cur) => {
            if (this.childTable.selectedRowKeys.includes(cur.id) && !pre.some(s => s.id === cur.id)) {
              pre.push(cur);
            }
            return pre;
          }, []);
          this.emitSelectCourse();
        },
      };
    },
  },
  mounted() {
    this.tabsChange();
  },
  methods: {
    emitSelectCourse() {
      this.$emit("change", this.childTable.selectedRows);
    },
    // 切换标签
    tabsChange() {
      function initData(arr, index) {
        return arr.map((m) => {
          if (m.id === null) {
            m.id = 0;
          }
          if (m.children && m.children.length) {
            m.children = initData(m.children, index + 1);
          }
          m.index = index;
          m.scopedSlots = { title: "treeItem" };
          return m;
        });
      }

      this.loading = true;
      this.$http.CourseResource.classificationsGet({ resourseType: 0, type: this.tabActive })
        .then((res) => {
          const { status, data, message } = res;
          this.tree.treeData = initData([data], 0);
          this.tree.key = Date.now();
        })
        .finally(() => {
          this.loading = false;
        });
      this.tree.selectValue = undefined;
      this.searchReset();
    },
    treeSelect(selectedKeys) {
      this.searchForm.classificationId = selectedKeys[0] || undefined;
      this.getSeriesList(1);
    },
    // 获取系列列表
    getSeriesList(page) {
      const Params = {
        type: this.tabActive,
        courseType: this.courseType,
        enabled: true,
        pageIndex: page || this.table.tablePagination.current,
        pageSize: this.table.tablePagination.pageSize,
        resourceType: 0,
        ...this.searchForm,
      };

      if (this.contentId) {
        Params.contentId = this.contentId;
      }

      this.table.tableLoading = true;
      this.$http.CourseResource.seriesGet(Params)
        .then(({ data }) => {
          this.table.tableDataSource = data.items;
          this.table.tablePagination.total = data.totalCount;
          this.table.tablePagination.current = data.pageIndex;
        })
        .finally(() => {
          this.table.tableLoading = false;
        });
    },
    searchReset() {
      this.searchForm = {
        name: undefined,
        remark: undefined,
      };
      this.getSeriesList(1);
    },
    // 获取系列下课程列表
    getCourseList(id) {
      let params = {
        courseSeriesId: id,
        courseType: this.courseType,
      };

      if (this.contentId) {
        params.contentId = this.contentId;
      }
      this.table.tableLoading = true;
      this.$http.CourseResource.courseAll(params)
        .then(({ data }) => {
          this.table.tableDataSource = this.table.tableDataSource.map((m) => {
            if (m.id === id) {
              let count = 0;
              m.tableData = data.filter((f) => {
                if (m.id == f.courseSeriesId && this.selectCourse.some((s) => s.id === f.id) && !this.childTable.selectedRowKeys.includes(JSON.stringify(f))) {
                  this.childTable.selectedRowKeys.push(JSON.stringify(f));
                  count++;
                }
                return f.courseSeriesId === m.id;
              });
              // 回显选中的系列
              if (count && count === m.tableData.length && !this.table.selectedRowKeys.includes(m.id)) {
                this.table.selectedRowKeys.push(m.id);
              }
              if (count) {
                this.defaultExpandedRowKeys.push(m.id);
              }
            }
            return m;
          });
        }).finally(() => {
          this.table.tableLoading = false;
        });
    },
    tableExpand(expanded, record) {
      expanded && this.getCourseList(record.id);
    },
  },
};
</script>

<template>
  <a-spin :spinning="loading">
    <div class="select-course">
      <div class="left-tree">
        <a-tabs @change="tabsChange" v-model="tabActive">
          <a-tab-pane v-for="item in tabs" :key="item.type" :tab="item.name" />
        </a-tabs>
        <a-tree
          @select="treeSelect"
          :tree-data="tree.treeData"
          style="padding-right: 5px"
          :key="tree.key"
          :selectedKeys.sync="tree.selectValue"
          :replaceFields="{ key: 'id' }"
          show-icon
          default-expand-all
          block-node
        >
          <div slot="treeItem" slot-scope="title" class="tree-item">
            <img v-if="!(title.children && title.children.length)" class="tree-icon"
                 src="@/assets/img/course/course-file.png" alt="" />
            <img v-else class="tree-icon" src="@/assets/img/course/course-folder.png" alt="" />
            <span :title="title.name">{{ title.name }}</span>
          </div>
        </a-tree>
      </div>
      <div class="right-table">
        <a-form-model layout="inline" :model="searchForm" class="search-form">
          <a-form-model-item label="课程系列">
            <a-input :maxLength="30" allowClear v-model="searchForm.name" placeholder="请输入系列名称" />
          </a-form-model-item>
          <a-form-model-item label="课程名称">
            <a-input :maxLength="30" allowClear v-model="searchForm.courseName" placeholder="请输入课程名称" />
          </a-form-model-item>
          <a-form-model-item label="系列说明">
            <a-input :maxLength="30" allowClear v-model="searchForm.remark" placeholder="请输入关键词" />
          </a-form-model-item>
          <a-form-model-item>
            <a-button @click="getSeriesList(1)" type="primary" html-type="button"> 查询</a-button>
            <a-button @click="searchReset" style="margin-left: 10px"> 重置</a-button>
          </a-form-model-item>
        </a-form-model>
        <a-table @expand="tableExpand"
                 :columns="columns"
                 row-key="id"
                 :pagination="table.tablePagination"
                 :loading="table.tableLoading"
                 :scroll="{ y: 350 }"
                 :dataSource="table.tableDataSource">
          <a-table
            slot="expandedRowRender"
            class="inner-table"
            slot-scope="text"
            :key="text.key"
            row-key="id"
            :columns="childColumns"
            :row-selection="childTableSelection"
            :data-source="text.tableData"
            :loading="text.tableLoading"
            :pagination="false"
          >
            <div class="course-name" slot="name" :title="text.name" slot-scope="text">
              <img :src="text.icon | filterUrl" alt="" />
              <span>{{ text.name }}</span>
            </div>
            <div slot="courseType" slot-scope="text">
              {{ text === 1 ? "测评课程" : text === 2 ? "训练课程" : "活动课程" }}
            </div>
            <div slot="price" slot-scope="text" style="color: red">￥{{ text }}</div>
          </a-table>
        </a-table>
      </div>
    </div>
  </a-spin>
</template>

<style scoped lang="less">
.select-course {
  display: flex;

  .left-tree {
    width: 300px;
    min-height: 300px;
    max-height: 550px;
    overflow-y: auto;
    flex-shrink: 0;
    border-right: 1px solid #ebedf0;
    border-bottom: 1px solid #ebedf0;

    .tree-item {
      display: flex;
      align-items: center;
    }

    .tree-item > span {
      flex-shrink: 2;
      flex-grow: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
    }

    .tree-icon {
      width: 16px;
      height: 16px;
      object-fit: contain;
      margin-right: 5px;
    }
  }

  .right-table {
    flex-grow: 1;
    padding-left: 24px;

    .course-name {
      display: flex;
      align-items: center;

      img {
        width: 25px;
        height: 25px;
        object-fit: contain;
        margin-right: 5px;
        flex-shrink: 0;
      }

      span {
        flex-grow: 2;
      }
    }
  }

  .inner-table /deep/ .ant-table-selection-column .ant-table-header-column {
    display: none;
  }
}
</style>
